import type {ThesaurusValue} from 'schemaDefinition/types';

export const removeNodeIdFromThesaurusValue = (
  nodeId: string,
  value: ThesaurusValue,
): ThesaurusValue => {
  return value.filter(v => v !== nodeId);
};
